import { useWorkspace } from '@/features/workspaces/hooks';
import { EditableTitle } from '@/global/components';
import { Audience } from '@/models/audiences';
import { useUpdateAudienceMutation } from '@/services/endpoints/audiences';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type AudienceEditableTitleProps = {
  audience?: Audience;
};

export const AudienceEditableTitle: FC<AudienceEditableTitleProps> = ({ audience }) => {
  const { t } = useTranslation();
  const workspace = useWorkspace();

  const [updateAudience, { isLoading: isUpdating }] = useUpdateAudienceMutation();

  const handleUpdate = async (item: Audience, newTitle: string) => {
    await updateAudience({
      workspaceId: workspace.id,
      audienceId: item.id,
      audience: {
        name: newTitle,
        expression: item.expression,
      },
    }).unwrap();
  };

  return (
    <EditableTitle
      item={audience}
      title={audience?.name || ''}
      onUpdate={handleUpdate}
      isLoading={isUpdating}
      successMessage={{
        title: t('audience_details:audience_updated_successfully'),
        message: t('audience_details:audience_name_updated_successfully'),
      }}
      errorMessage={{
        title: t('audience_details:audience_updated_error'),
        message: t('audience_details:audience_name_updated_error'),
      }}
    />
  );
};
